import config from "config";

// List of client IDs
const CLIENT_IDS = config.CLIENT_IDS; // Add more as needed

// Dynamically generate LOCUS config based on client IDs
const LOCUS_CONFIG = CLIENT_IDS.reduce(
  (acc, clientId) => {
    acc[clientId] = {
      LOCUS_DASH_BASE_URL: config[`REACT_APP_DASH_API_BASE_URL`],
      LOCUS_PROD_BASE_URL: config[`REACT_APP_LOCUS_API_BASE_URL`],
      LILY_PAYMENT_BASE_URL: config[`REACT_APP_LILY_PAYMENTS_API_BASE_URL`]
    };
    acc["LILY_API"][`LILY_PROD_BASE_URL_${clientId}`] =
      config[`REACT_APP_LILY_API_BASE_URL`];
    return acc;
  },
  { LILY_API: {} }
);


export const CONFIG = {
  TIMEZONE: "Asia/Bangkok",
  stackDomain: config.STACK_DOMAIN,
  LOCUS: LOCUS_CONFIG, // Insert dynamically generated LOCUS config
  CSV: {
    MAX_FILE_SIZE: 50 * 1024 * 1024, // 50 MB
  },
};
console.log(CONFIG)
